<template>
	<div class="c-s">
		<van-overlay :show="isShow" @click="_click(false) " z-index="4">
			<div class="wrapper">
				<div style="">

					<div class="ant-modal-content" @click.stop>
						<div class="ant-modal-header">
							<div id="rcDialogTitle1" class="ant-modal-title">{{ $t('withdraw._InserirSenha') }}</div>
						</div>
						<div class="ant-modal-body">
							<div class="Ou1aviPriFX421w97dGA">
								<span>{{ $t('withdraw._VerificarSenhadeSaque') }}e</span>
								<i @click="isShowNum=!isShowNum" :class="{
											isShowNum:isShowNum
										}">
									<svg-icon className="ZaAWGnvFuhPwlBk40od_"
										:icon-class="`${isShowNum?'comm_icon_show--svgSprite:all':'comm_icon_hide--svgSprite:all'}`" />
								</i>
							</div>
							<div class="gD0G2pAAJZZTJ1n0KQXv">
								<ant-input-password :isShow="isShowNum" @change="newPassword"
									style="margin-bottom: .5rem;">
								</ant-input-password>
							</div>
							<div class="Kw58s_FCuipHRV_EW4tG"><span>{{ $t('withdraw._Paraasegurança') }}</span><span
									class="_7B8oTwzAn2VmdNYw3F0z">{{ $t('withdraw._EsqueceuaSenha') }}</span></div>
							<div class="Pt3rGlTmq0_WLpTGHsA_">
								<van-button class="JHBAn8W0jkHI1OM_X2fy"
									type="primary">{{ $t('withdraw._Próximo') }}</van-button>
							</div>
						</div>


					</div>
					<div @click="_click(false)" class="QzRd3YqTnYxG8Latq8fW closeIcon"><img
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
							alt="." data-blur="0" data-status="loaded" class="goDRiiBsuEuXD3W1NphN"></div>
				</div>

			</div>
		</van-overlay>

	</div>
</template>

<script>
	import antInputPassword from "@/components/ant-input-password/index.vue"
	export default {
		props: {
			isShow: {
				type: Boolean,
				default: false,
			}
		},
		components: {
			antInputPassword
		},
		data() {
			return {
				isShowNum: false,
			}
		},

		methods: {
			_click() {
				this.$emit('_click', false)
			}
		}
	}
</script>
<style>
	/* 	.c-s{
		width: 100%;
		height: 100vh;
	} */
	.c-s {
		width: 100vw;
	}

	.c-s .van-overlay {
		width: 100vw;
		/* position: absolute;
		    background-color: rgba(0, 0, 0, .45); */
	}
</style>
<style scoped>
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
	}

	.ant-modal-content {
		background-color: var(--theme-main-bg-color);
		border-width: thin;
		border-style: solid;
		border-image: initial;
		box-sizing: border-box;
		width: 6.9rem;
		border-color: var(--theme-color-line);
		border-radius: 0.2rem;
		max-height: calc(var(--vh, 1vh)*100 - .1rem);
		overflow: auto;
		position: static;
		margin: 0 auto;
	}

	.ant-modal-header {
		background-color: var(--theme-main-bg-color);
		border-bottom: none;
		border-radius: .2rem .2rem 0 0;
		padding: .2rem .3rem
	}

	.ant-modal-title {
		color: var(--theme-text-color-darken);
		font-size: .24rem;
		font-weight: revert;
		line-height: .34rem;
		text-align: center;
	}

	.Ou1aviPriFX421w97dGA {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: .15rem;
		font-size: .22rem;
		color: var(--theme-text-color-darken);
	}

	.Ou1aviPriFX421w97dGA .ZaAWGnvFuhPwlBk40od_ {
		font-size: .36rem;
		width: .36rem;
		height: .36rem;
		color: var(--theme-text-color-lighten);
	}

	.Ou1aviPriFX421w97dGA .isShowNum .ZaAWGnvFuhPwlBk40od_ {
		color: var(--theme-primary-color);
	}

	.ant-modal-body {
		padding-top: .2rem !important;
		padding: .3rem;
	}

	.Kw58s_FCuipHRV_EW4tG {
		color: var(--theme-text-color-darken);
		font-size: .22rem;
		display: flex;
	}

	._7B8oTwzAn2VmdNYw3F0z {
		color: var(--theme-primary-color);
		cursor: pointer;
		text-align: right;
	}

	.closeIcon {}

	.QzRd3YqTnYxG8Latq8fW {
		background: none;
		height: .64rem;
		width: .64rem;
		margin: 0 auto;
	}

	.QzRd3YqTnYxG8Latq8fW img {
		width: 100%;
		height: 100%;
	}

	.JHBAn8W0jkHI1OM_X2fy {
		border-radius: .14rem;
		font-size: .24rem;
		width: 100%;
		height: .7rem;
		background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
		line-height: .7rem;
	}
</style>